module.exports = __webpack_public_path__ + "static/img/1.6e88f48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/1.png
// module id = 1HYe
// module chunks = 0